import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { 
  Container, 
  Title, 
  Description,
  CardsGrid, 
  DocCard, 
  CardIcon,
  CardTitle, 
  CardDescription,
  CloseButton
} from './style'
import { FileText, Workflow, Code, BookOpen, Settings, X, Server, Database } from 'lucide-react'

interface DocItem {
  id: string
  title: string
  description: string
  path: string
  icon: React.ReactNode
}

const getIconForDoc = (docId: string): React.ReactNode => {
  const iconMap: Record<string, React.ReactNode> = {
    'frontend-guide': <Code size={40} />,
    'backend-guide': <Server size={40} />,
    'deployments': <Workflow size={40} />,
    'prisma': <Database size={40} />,
  }
  return iconMap[docId] || <BookOpen size={40} />
}

const getTitleForDoc = (docId: string): string => {
  const titleMap: Record<string, string> = {
    'frontend-guide': 'Guia do Frontend',
    'backend-guide': 'Guia do Backend',
    'deployments': 'Implantações',
    'prisma': 'Prisma Centralizado',
  }
  return titleMap[docId] || docId.split('-').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ')
}

const getDescriptionForDoc = (docId: string): string => {
  const descMap: Record<string, string> = {
    'frontend-guide': 'Documentação e boas práticas para desenvolvimento frontend',
    'backend-guide': 'Documentação do Automation-Service e regras de automação JSON',
    'deployments': 'Automação Kafka, Otimização de Banco de Dados e Multi-Tenancy',
    'prisma': 'Git Submodules, Migrations e fluxo de deploy do prisma-shared',
  }
  return descMap[docId] || 'Documentação técnica do projeto'
}

const DocsIndex: React.FC = () => {
  const navigate = useNavigate()
  const [docs, setDocs] = useState<DocItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const knownDocs = [
      'frontend-guide',
      'backend-guide',
      'deployments',
      'prisma'
    ]

    const docItems = knownDocs.map(docId => ({
      id: docId,
      title: getTitleForDoc(docId),
      description: getDescriptionForDoc(docId),
      path: `/panel/docs/${docId}`,
      icon: getIconForDoc(docId)
    }))

    setDocs(docItems)
    setLoading(false)
  }, [])

  const handleCardClick = (path: string) => {
    navigate(path)
  }

  if (loading) {
    return (
      <Container>
        <Title>📚 Carregando...</Title>
      </Container>
    )
  }

  return (
    <Container>
      <CloseButton onClick={() => navigate('/panel')} title="Voltar ao painel">
        <X size={20} />
      </CloseButton>
      
      <Title>📚 Documentação</Title>
      <Description>
        Selecione uma documentação para visualizar (Acesso exclusivo ADMIN_GLOBAL)
      </Description>

      <CardsGrid>
        {docs.map((doc) => (
          <DocCard key={doc.id} onClick={() => handleCardClick(doc.path)}>
            <CardIcon>{doc.icon}</CardIcon>
            <CardTitle>{doc.title}</CardTitle>
            <CardDescription>{doc.description}</CardDescription>
          </DocCard>
        ))}
      </CardsGrid>
    </Container>
  )
}

export default DocsIndex
